import React, { useState } from 'react';
import { Table, Button, Form, Row, Col, Card } from 'react-bootstrap';
import { FaPlus, FaSave, FaTimes, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

const GridIPTU = ({ codigoFamilia, iptu, permissoes, onRecarregar }) => {
  const [showForm, setShowForm] = useState(false);
  const [ano, setAno] = useState('');
  const [valorGeralIptu, setValorGeralIptu] = useState('');
  const [salvando, setSalvando] = useState(false);

  const handleAbrirForm = () => {
    setAno('');
    setValorGeralIptu('');
    setShowForm(true);
  };

  const handleIncluir = async () => {
    setSalvando(true);
    try {
      await api.incluirIptuConfig({
        codigo_familia: codigoFamilia,
        ano: ano !== '' ? Number(ano) : null,
        valor_geral_iptu: valorGeralIptu !== '' ? Number(valorGeralIptu) : null,
      });
      toast.success('IPTU incluído com sucesso!');
      setShowForm(false);
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao incluir IPTU';
      toast.error(msg);
    } finally {
      setSalvando(false);
    }
  };

  const handleExcluir = async (item) => {
    if (!window.confirm(`Excluir IPTU do ano ${item.ano}?`)) return;
    try {
      await api.excluirIptuConfig({
        codigo_familia: codigoFamilia,
        ano: item.ano,
      });
      toast.success('IPTU excluído!');
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao excluir IPTU';
      toast.error(msg);
    }
  };

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex justify-content-between align-items-center py-2">
        <strong>IPTU</strong>
        <Button
          size="sm"
          variant="outline-primary"
          onClick={handleAbrirForm}
          disabled={!permissoes.projeto}
        >
          <FaPlus className="mr-1" /> Incluir
        </Button>
      </Card.Header>
      <Card.Body className="p-0">
        {showForm && (
          <div className="p-3 border-bottom bg-light">
            <Row>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Ano</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    maxLength={4}
                    value={ano}
                    onChange={(e) => setAno(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Valor Geral IPTU</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    step="0.01"
                    value={valorGeralIptu}
                    onChange={(e) => setValorGeralIptu(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <div className="mt-2">
              <Button
                size="sm"
                variant="success"
                className="mr-2"
                onClick={handleIncluir}
                disabled={salvando}
              >
                <FaSave className="mr-1" /> Salvar
              </Button>
              <Button
                size="sm"
                variant="secondary"
                onClick={() => setShowForm(false)}
                disabled={salvando}
              >
                <FaTimes className="mr-1" /> Cancelar
              </Button>
            </div>
          </div>
        )}
        <div style={{ maxHeight: 300, overflowY: 'auto' }}>
        <Table striped bordered hover size="sm" className="mb-0">
          <thead>
            <tr>
              <th>Ano</th>
              <th>Valor Geral IPTU</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {iptu.length === 0 && (
              <tr>
                <td colSpan={3} className="text-center text-muted">
                  Nenhum IPTU cadastrado
                </td>
              </tr>
            )}
            {iptu.map((item) => (
              <tr key={`iptu-${item.ano}`}>
                <td>{item.ano}</td>
                <td>{item.valor_geral_iptu}</td>
                <td>
                  <Button
                    size="sm"
                    variant="outline-danger"
                    title="Excluir"
                    onClick={() => handleExcluir(item)}
                    disabled={!permissoes.projeto}
                  >
                    <FaTrash />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default GridIPTU;
